<span *ngIf="major" triggers="mouseenter:mouseleave" placement="right"
      [ngbPopover]="major ? 'Major' : !major ? '' : major ? 'Major' : null">
  <span [ngClass]="major ? 'major' : 'empty'">M</span>
</span>
